import { useContext, useEffect, useRef } from 'react';
import Layout from '../Layout';
import * as components from './components';
import {
  h2ClassLg,
  smFontClass,
} from './helpers';
import { goSolarReasonsEnphase, faqs } from './staticData';
import AppContext from '../../contexts/AppContext';
import ConfigContext from '../../contexts/ConfigContext';

export default function Faqs() {

  const { setLoadedFaqsPage } = useContext(AppContext);
  const { features } = useContext(ConfigContext);

  const whyRef: any = useRef(null);

  useEffect(() => {
    if(window.location.hash === '#why') {
      whyRef?.current?.scrollIntoView();
    }
    setLoadedFaqsPage(true);
    if (features.showLanderConcept) {
      setTimeout(() => {
        const root = document.documentElement;
        root.classList.remove('lander-concept');
      });
    }
  }, []);

  return (
    <Layout addPadding={false} className='text-[14px] md:text-[20px]'>


      <div className='pt-[50px] md:pt-40 px-6 md:px-20'>
        <div className='max-w-[1060px] m-auto'>
          <p className='text-[22px] md:text-[42px] leading-tight md:mb-[50px] text-center text-black'>
            Frequently asked questions about solar
          </p>
          <components.Faqs faqs={faqs}></components.Faqs>
        </div>
      </div>

      <div className='max-w-[1280px] m-auto px-6 md:px-[60px] break-words'>
        <p ref={whyRef} className={`${h2ClassLg} mt-5 md:mt-[130px]`}>
          Why you shouldn’t wait
          <br className='md:hidden' /> to go solar
        </p>
        <div className='mt-[50px] md:mt-[80px] flex flex-wrap justify-between gap-y-10 md:gap-y-20'>
          {goSolarReasonsEnphase.map((reason: any, index: number) => (
            <components.GoSolarReason
              key={index}
              reason={reason}
              className='basis-full md:basis-[45%]'
            ></components.GoSolarReason>
          ))}
        </div>
        <p
          className={`${smFontClass} leading-loose mt-[50px] md:mt-[80px] mb-[40px] md:mb-[120px]`}
        >
          <sup>1</sup>{' '}
          <a href='https://www.eia.gov/outlooks/steo/report/electricity.php' target='_blank' rel='noreferrer'>
            https://www.eia.gov/outlooks/steo/report/electricity.php
          </a>
          <br />
          <sup>2</sup>{' '}
          <a href='https://www.energy.gov/eere/solar/homeowners-guide-federal-tax-credit-solar-photovoltaics' target='_blank' rel='noreferrer'>
            https://www.energy.gov/eere/solar/homeowners-guide-federal-tax-credit-solar-photovoltaics
          </a>
          <br />
          <sup>3</sup>{' '}
          <a href='https://www.zillow.com/research/solar-panels-house-sell-more-23798/' target='_blank' rel='noreferrer'>
            https://www.zillow.com/research/solar-panels-house-sell-more-23798/
          </a>
        </p>
      </div>
      <components.Footer></components.Footer>
    </Layout >
  );
}